// File validation utilities

export const isValidFileType = (file) => {
  const validTypes = ['application/EDI-X12', 'text/plain', 'image/jpeg', 'image/jpg'];
  const validExtensions = ['.x12', '.jpg', '.jpeg'];
  const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
  return validTypes.includes(file.type) || validExtensions.includes(fileExtension);
};

export const isValidFile = (file, maxFileSizeInBytes = 5000000) => {
  return isValidFileType(file) && file.size < maxFileSizeInBytes;
}; 